/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ECurrency = 'DKK' | 'EUR' | 'USD';

export const ECurrency = {
    Dkk: 'DKK' as ECurrency,
    Eur: 'EUR' as ECurrency,
    Usd: 'USD' as ECurrency
};

